import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import useMobileDetect from 'use-mobile-detect-hook';

const MapContainer = (props) => {
  const detectMobile = useMobileDetect();

  const mapStyles = {
    height: detectMobile.isMobile() ? '50vh' : '90vh',
    width: '100%',
    minHeight: '100%',
    maxHeight: 'none',
  };

  const defaultCenter = {
    lat: 44.1513,
    lng: -94.0005,
  };

  return (
    <LoadScript googleMapsApiKey='AIzaSyAq6UMC6JJSMcZGC77bqsYjUQoaE76nqWE'>
      <GoogleMap mapContainerStyle={mapStyles} zoom={detectMobile.isMobile() ? 11 : 13} center={defaultCenter}>
        {props.listings.map((val) => {
          return (
            <Marker
              onClick={(evt) => {
                props.itemSelect(val);
              }}
              icon= 'houseIcon.png'
              key= {val.listingId}
              position={{ lat: val.latitude, lng: val.longitude }}
              title={val.listingAddress}
            />
          );
        })}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapContainer;